<template>



    <div class="row">  
                    


        <div class="col-lg-12">
            <h3 class="entry-title"> <i class="fas fa-lock"></i> EasyCheck</h3>   
        </div> 


        <div class="wrap">
          <h3 class="entry-title">
            Weryfikacja EasyCheck zakończona.
          </h3>


          <h3 class="entry-title">
             
          </h3>


          <div class="form-group form-btn-wrap column col-10 col-mx-auto">

            

          </div>


        </div>
    </div>



</template>

<script>

    
    //import { bus } from './main';    

    // sha256
    //import sha256 from 'crypto-js/sha256';


    export default {
     
       name: 'EasyCheckOkView',

        data(){

            return {

              modal: null,

              details: '',



              waitCount: 0
              
            }
       },


       methods: {


            gotomain(){


                this.$router.push({path: '/'});

            },



            onWaiting( endpoint='application' ) {


              var page = this.$root.mainpage,
                  step,


                poll = () => {

                  if (this.waitCount > 60) {

                    page.isLoading =false;

                    this.$router.push({path: 'pending'});
                    return;
                  }

                  this.waitCount++;


                  this.get( '/' + endpoint )
                      .then(response => {
                       

                        if (!!response.data) {

                          step = response.data.hasOwnProperty('step') ? response.data.step : '';


                          !step.match(/wait|kontomatik/) 
                            && this.log( 'easycheck done - status polling done, go to ' + step );

        //console.log(step);

                          switch (step) {

                            case 'kontomatik':
                            case 'wait':
                              break;


                            case 'counteroffer':

                              page.isLoading =false;


                              // flag to make sure step was completed
                              page.aisdone = true;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_success',                    
                                loan_amount: this.loanAmount,
                                user_email: SHA256(this.form.client_email),
                                user_phone: SHA256(this.form.client_cellphone)
                              });*/




                              this.finishDate = response.data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');



//console.log(this.finishDate);


                              this.setValues( parseInt(response.data.net_amount),  parseInt(response.data.installments_nbr), this.getConf('tenor_sign'), this.finishDate );




//console.log(this.finishDate);





                              this.$router.push({path: 'proposal'});
                              break;

                                               

                            case 'reject':
                                page.isLoading =false;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_failed',                    
                                loan_amount: this.loanAmount,
                                user_email: sha256(this.form.client_email),
                                user_phone: sha256(this.form.client_phone)
                              });*/


                              this.$router.push({path: 'rej'});
                              return;


                            case 'amodit':
                              page.isLoading=false;

                              let url = response.data.step_details.split('/');

                              window.location = this.getConf('amoditSignUrl') + url[ url.length - 2 ] + '%2F' + url[ url.length - 1 ];
                              return;


                            default:
                              page.isLoading =false;
                              this.$router.push({path: 'thankyou'});
                              return;
                          }


        //console.log(response.data)

                       
                        }
                        else {
                          console.log('status empty body');
                        }


                        // dispatch another poll request
                        page.isLoading
                          && setTimeout(poll, 3000);                



                      })
                      .catch(error => {
                       
                          // wait for timeout
                          //page.isLoading = false;
                          setTimeout(poll, 3000);

             
                          // Error 
                          if (error.response) {
                         

                          } else if (error.request) {
                            
                          } else {
                              // Something happened in setting up the request and triggered an Error
                              //console.log('Error', error.message);
                          }
                      });


                };


                // log 
                this.log( 'easycheck done - status polling start' );


                // initial polling
                setTimeout(poll, 3000);
            }


            
       },


       created(){

        

       },
 

       created() {


   

            var page = this.$root.mainpage,
                me = this,
                uri = window.location.href.split('?'),
                lid = null;




// get status - for test of counteroffer on next screen only
//page.isLoading = true;
//me.onWaiting(); 
//return;




            if (uri.length > 1 && /lid=[0-9]+/.test(uri[1]) ) {


              let reg = uri[1].match(/lid=([0-9]+)/);

              lid = reg[1];
            }





//console.log('t10l created');

            me.log( 'easycheck page visible' );




            !!lid && me.post( '/transactionlink', {
                              "loan_id": lid,
                              "t10l":  'easycheck'
                          
            })
            .then(response => {

                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);

                  // get status
                  page.isLoading = true;

                  me.onWaiting();              

                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {        

                     console.log(error.response);
                  }                                  
              });











/*setTimeout(() => {
     
 var elems = document.getElementsByTagName('iframe');

                for (var i = 0; i<elems.length; i++) {
                   
                        elems[i].style.maxWidth = 'auto';
                    
                }




    }, 500);

          */ 


          // scroll to top
          this.pageTop();

       }



        
    }
</script>



<style scoped>

h3 i {
    color: #0bc268;
}

.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}







</style>


// WEBPACK FOOTER //
// src/EasyCheckOkView.vue